import axios from 'axios';
import { systemOf } from '../constants/systems';

/**
 * Keys every master-control body carries besides the program keys.
 * @typedef {Object} MasterControlHeader
 * @property {number} commandNumber  from GET /audits/command-number
 * @property {string} actionType  ACTION_TYPES.MASTER_CONTROL, LOCAL_MASTER_CONTROL,
 *   GLOBAL_MASTER_CONTROL or FAST_MASTER_CONTROL
 */

/**
 * POST /{switches|blowers}/master-control. Bodies come from `masterControlPayload`
 * (via `backendDispatches`), `globalMasterControlPayload` or `fastMasterControlPayload`.
 * @param {'ess'|'tgs'|'tes'} system  a DEVICE_TYPES value works too
 * @param {string[]} deviceIds  device MACs
 * @param {MasterControlHeader & Object<string, *>} data
 * @returns {Promise<*>}  `response.data.data`; no caller reads it
 */

export const masterControl = async (system, deviceIds, data) => {
  const { resource, deviceType } = systemOf(system);
  const response = await axios.post(`/${resource}/master-control`, {
    deviceIds,
    deviceType,
    ...data,
  });
  return response.data?.data;
};
